import { formatCurrencyMinor } from "@tinkr/shared/currency";
import type { AppLocale } from "../i18n";

// Display-only money formatting. ALL amounts are integer minor units coming from
// /api; we NEVER do *100 / /100 here — the shared formatter handles per-currency
// decimals (JPY 0-decimal, USD 2-decimal, etc.).
export function formatMoney(amountMinor: number, currency: string, locale: AppLocale): string {
  return formatCurrencyMinor(amountMinor, currency, locale);
}
